import { Fee } from 'types/FeeEntity'
import { formatPercentage } from '../../packages/utils/numberFormatters'

export function getFeeDescription(fee: Fee) {
    const percent = (p: number | null) => formatPercentage(p, { locale: 'sv', minDecimals: 0, maxDecimals: 1 })

    if (fee.feeCash && fee.feeUnits) {
        return `${percent(fee.feeCash)} kontant ${fee.feeBoth ? 'och' : 'eller'} ${percent(
            fee.feeUnits,
        )} i aktier/units.`
    }
    if (fee.feeCash) {
        return `${percent(fee.feeCash)} kontant.`
    }
    if (fee.feeUnits) {
        return `${percent(fee.feeUnits)} i aktier/units.`
    }
    return null
}
